import UserLayout from '@/components/layouts/UserLayout'
import RouteView from '@/components/layouts/RouteView'
import MainLayout from '@/components/layouts/MainLayout'
import SubLayout from '@/components/layouts/SubLayout'
export { UserLayout, RouteView, MainLayout, SubLayout }
